var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSravnenie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.5v1c0 .281.219.5.5.5h7c.25 0 .5-.219.5-.5V4.812c.125-.062.25-.156.375-.218l4.469 1.468a.477.477 0 00.625-.312l.312-.938c.094-.28-.062-.562-.312-.625l-4.032-1.343c.032-.125.063-.219.063-.344C12.5 1.125 11.375 0 10 0c-.937 0-1.75.531-2.187 1.281L4.125.031A.531.531 0 003.5.344l-.312.969c-.094.25.062.53.312.625l4.125 1.375a2.464 2.464 0 001.344 1.5V14H3.5c-.281 0-.5.25-.5.5zm-3-5C0 10.906 1.781 12 4 12c2.188 0 4-1.094 4-2.5h-.03c0-.469.094-.219-2.656-5.656-.532-1.094-2.125-1.094-2.657 0C-.062 9.25 0 9 0 9.5zM1.75 9L4 4.5 6.25 9h-4.5zM12 13.5c0 1.406 1.781 2.5 4 2.5 2.188 0 4-1.094 4-2.5h-.031c0-.469.093-.219-2.657-5.656-.53-1.094-2.125-1.094-2.656 0C11.937 13.25 12 13 12 13.5zm1.75-.5L16 8.5l2.25 4.5h-4.5z",
    fill: "#1B130E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSravnenie);
export default __webpack_public_path__ + "static/media/sravnenie.d4c1c692adbe0f48e87562226e3e094b.svg";
export { ForwardRef as ReactComponent };